module.exports = __webpack_public_path__ + "img/corsica.a9d8fe21.png";